<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section">
          <div v-if="!isView">
            <el-button type="primary" no="1" @click="cancelSave">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            <el-button type="primary" no="2" :disabled="btnSaveEnable" @click="saveBillingGroupDetail">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          </div>
          <div>
            <el-button v-if="isView" no="3" type="primary" @click="backEvent">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
            <el-button v-if="isView && $checkPermission(['button_ACTBilling_editBillingGroup']) && !hasAgentBilling" no="4" type="primary" @click="editBillingGroup">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-if="isView && billingGroup && billingGroup.uuid && $checkPermission(['button_ACTBilling_createInvoiceFromBillingGroup']) && !hasAgentBilling" no="5" type="primary" @click="makeInvoiceEvent">{{ !billingGroup.ar ? $t('CargoMsg.Cargo_CollectInvoice') : $t('CargoMsg.Cargo_Invoicing') }}</el-button>
            <el-button v-if="isView && billingGroup && billingGroup.uuid && $checkPermission(['button_ACTBilling_writeoffBillingGroup'])" no="6" type="primary" @click="writeoffHandler">{{ $t('Billing.billingView_writeOff') }}</el-button>
            <el-button v-if="isView && billingGroup && billingGroup.uuid && !billingGroup.ar && $checkPermission(['button_ACTBilling_payauthBillingGroup']) && !hasAgentBilling" no="7" type="primary" @click="doBillPayment">{{ $t('CargoMsg.Cargo_ApplyForPayment') }}</el-button>
            <el-button v-if="isView && billingGroup && billingGroup.uuid && !hasAgentBilling" no="8" type="primary" @click="printEvent">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          </div>
        </div>
        <div v-show="!expandedGrid" class="main-content" style="flex-grow: unset;margin-bottom: 5px">
          <el-form ref="basicForm" label-position="left" label-width="110px" :model="billingGroup">
            <el-row type="flex" :gutter="5">
              <el-col :span="7" style="width: 550px;">
                <div class="section" style="height: 100%">
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_AccountStatementNo')">
                      <el-input v-model="billingGroup.billingNo" :disabled="true" no="9" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_DateOfDocument')">
                      <el-date-picker
                        v-model="billingGroup.inputDate"
                        no="10"
                        type="date"
                        clearable
                        style="width: 100%"
                        :disabled="isView"
                        @change="inputDateChange"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoiceTitle')">
                      <cargo-advance-select
                        no="11"
                        :select-type="selectTypeNames.static_data_Title"
                        :allow-create="!arSettlementUnitOptional || !billingGroup.ar"
                        filterable
                        :cache="false"
                        :disabled="isView"
                        :default-value="billingGroup.title"
                        :static-options="titleArray"
                        @parentCallBack="titleChangeEvent"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_RegistrationAddress')">
                      <el-input v-model="billingGroup.buyerAddress" :disabled="isView" no="12" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_RegistrationNumber')">
                        <el-input v-model="billingGroup.buyerTaxAccount" :disabled="true" no="13" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                        <el-input v-model="billingGroup.buyerTelephone" :disabled="isView" style="width: 152px;" no="14" />
                      </el-form-item>
                    </el-col>

                  </el-col>
                  <el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_DepositBank')">
                        <cargo-advance-select
                          no="15"
                          filterable
                          :select-type="selectTypeNames.static_data_TitleBank"
                          :default-value="billingGroup.buyerBank"
                          :disabled="isView"
                          :cache="false"
                          tag-value="bank"
                          :static-options="titleBankArray"
                          @parentCallBack="getBankCusFromChild"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                        <el-input v-model="billingGroup.buyerBankAccount" :disabled="true" style="width: 152px;" no="16" />
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_RevenueAndExpenditureType')">
                        <el-input :disabled="true" :value="billingGroup.ar ? $t('CargoMsg.Cargo_Receivable') : $t('CargoMsg.Cargo_Dues')" no="17" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_Amount')">
                        <el-input-number v-model="billingGroup.amount" :disabled="true" :precision="2" :controls="false" style="width: 152px;" no="18" />
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
                      <cargo-advance-select
                        no="19"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{'auto_accountId': true}"
                        callback-method-type="value"
                        :default-value="Number(billingGroup.accountId)"
                        :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                        :disabled="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicingRequirements')">
                      <el-input v-model="billingGroup.invoiceDemand" :disabled="isView" no="20" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_OwnerBankOfDeposit')">
                        <cargo-advance-select
                          no="21"
                          filterable
                          :select-type="selectTypeNames.static_data_BankAccount"
                          :cache="false"
                          :default-value="Number(billingGroup.bankAccountId)"
                          :disabled="isView"
                          :static-options="ourBankAccountArray"
                          @parentCallBack="getOurBankAccountFromChild"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                        <el-input v-model="ourBankAccountNo" :disabled="true" style="width: 152px;" no="22" />
                      </el-form-item>
                    </el-col>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_TotalCurrency')">
                      <el-input v-model="billingGroup.currencyAmount" :disabled="true" no="23" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('Billing.billingJob_otherPartyBilling')">
                      <el-input v-model="billingGroup.otherPartyBilling" :disabled="isView" no="24" />
                    </el-form-item>
                  </el-col>
                </div>
              </el-col>
              <el-col :span="17" style="padding-left: 5px;flex: 1;height: auto">
                <div class="section" style="height: 100%">
                  <div style="display: flex;">
                    <el-col v-show="billingGroup.billingType === '国内账单'">
                      <el-form-item :label="$t('Invoice.invoice_invoiceCategory')">
                        <el-select v-model="billingGroup.invoiceMakeType" no="26" :placeholder="isView ? '' : $t('CargoMsg.Cargo_PleaseSelect')" :disabled="isView" clearable @change="changeInvoiceMakeType">
                          <el-option v-for="(item,index) in invoiceMakeTypes" :key="index" :label="item.chineseName" :value="item.code" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col v-show="billingGroup.billingType === '国内账单'">
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
                        <el-select v-model="billingGroup.invoiceType" :disabled="isView" no="25" :placeholder="isView ? '' : $t('CargoMsg.Cargo_PleaseSelect')" clearable>
                          <el-option v-for="(item,index) in invoiceTypes" :key="index" :label="item.chineseName" :value="item.code" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </div>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicingAddress')">
                      <el-input v-model="billingGroup.billingAddress" type="textarea" no="27" :rows="7" :disabled="isView" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                      <el-input v-model="billingGroup.remark" type="textarea" no="28" :rows="7" :disabled="isView" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('Invoice.invoice_invoiceRemarks')">
                      <el-input v-model="billingGroup.invoiceRemark" type="textarea" no="29" :rows="6" :disabled="isView" />
                    </el-form-item>
                  </el-col>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="section" style="text-align: center">
          <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
        </div>
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('CargoMsg.Cargo_Bill')" name="bill" :lazy="true">
              <div class="section">
                <div v-if="!isView">
                  <el-button type="primary" no="30" @click="addBilling">{{ $t('CargoMsg.Cargo_JoinBill') }}</el-button>
                  <el-button type="primary" no="31" @click="removeBilling">{{ $t('CargoMsg.Cargo_DeleteBill') }}</el-button>
                </div>
                <div class="grid-wrapper" style="margin-top: 10px;">
                  <cargo-ag-grid
                    config-module="190908"
                    :grid-options="billingGridOptions"
                    :column-defs="billingColumnDefs"
                    :grid-params.sync="billingGridParams"
                    :row-data="billingRowData"
                    :style="{width:'100%'}"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="billingGroup.uuid" :label="$t('CargoMsg.Cargo_Cost')" name="charge" :lazy="true">
              <div class="section">
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    config-module="190909"
                    :grid-options="chargeGridOptions"
                    :column-defs="chargeColumnDefs"
                    :grid-params.sync="chargeGridParams"
                    :row-data="chargeRowData"
                    :style="{width:'100%'}"
                  />
                </div>
                <div class="pagination-wrapper">
                  <cargo-pagination
                    :total="searchConditions.total"
                    :page.sync="searchConditions.pageNum"
                    :limit.sync="searchConditions.pageSize"
                    @pagination="fetchDataByPage"
                  />
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="billingGroup.uuid" :label="$t('CargoMsg.Cargo_Business')" name="job" :lazy="true">
              <div class="section">
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    config-module="190910"
                    :grid-options="jobGridOptions"
                    :column-defs="jobColumnDefs"
                    :grid-params.sync="jobGridParams"
                    :row-data="jobRowData"
                    :style="{width:'100%'}"
                  />
                </div>
                <div class="pagination-wrapper">
                  <cargo-pagination
                    :total="searchConditions.total"
                    :page.sync="searchConditions.pageNum"
                    :limit.sync="searchConditions.pageSize"
                    @pagination="fetchDataByPage"
                  />
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <!--加入账单-->
      <join-bill-dialog
        v-if="showJoinBillDialog"
        :visible.sync="showJoinBillDialog"
        :add-billing-conditions="addBillingConditions"
        :only-has-agent-bill="addBillingConditions.onlyHasAgentBill"
        @backBillingGroupDetail="backBillingGroupDetail"
      />
      <!--开票-->
      <make-invoice-dialog
        ref="invoice"
        :location="location"
        view-source="billGroupDetail"
      />

      <!--打印-->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :pre-print-callback="prePrintCallback"
      />

      <!--申请付款-->
      <bill-payment-dialog
        ref="billPayment"
        :visible.sync="showBillPaymentDialog"
        :create-submit="true"
        :location="location"
        step="step2"
        mode="overview"
        @cancel="cancelBillPayment"
      />
      <!--销账-->
      <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :properties="properties" />
    </div>
  </div>
</template>

<script>
import joinBillDialog from './joinBillDialog'
import {
  getBillingGroupDetail,
  loadBillingOfBillingGroup,
  loadBillingChargeOfBillingGroup,
  loadBillingJobOfBillingGroup,
  saveBillingGroup
} from '@/api/clearing/billingNative'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { queryTitleByCpmIdx } from '@/api/partner/title'

import { getGridSelected } from '@/utils/agGrid'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { getLoading } from '@/utils/utilBaseElement'
import { queryParentOffice } from '@/api/office'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCustomer } from '@/api/partner/customer'
import { getTitleBankList } from '@/api/partner/titleBank'
import { getBankAccountList } from '@/api/bankAccount'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import { cacheName, cache } from '@/utils/cacheManager'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { getCurrencyAmount } from '@/api/clearing/billingNative'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import StrUtils from '@/utils/StrUtils'
import moment from 'moment'
import { BillingGroup } from '@/class/model/act/BillingGroup'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import * as NumberUtils from '@/utils/NumberUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'

export default {
  name: 'BillGroupDetail',
  components: { CargoAdvanceSelect, joinBillDialog, makeInvoiceDialog, cargoTemplateSelectorDialog, billPaymentDialog, writeOffDialog },
  props: {
    viewSource: { type: String, required: true },
    billingGroupUuid: { type: String },
    viewBillingGroup: { type: Boolean },
    newBillingGroup: { type: Object },
    newBillings: { type: Array },
    location: { type: String, required: false },
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      loading: null,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      showJoinBillDialog: false,
      activeTabName: 'bill',
      isView: this.viewBillingGroup,
      expandedGrid: false,
      actionSource: this.viewSource, // 记录请求动作是来自账单(bill)还是对账单(billGroup)
      billingGroup: new BillingGroup().fillDefaultValue().getData(),
      ourBankAccountNo: '', // 我司银行账号（虚拟字段，不入库）
      billingGridOptions: {
        rowSelection: 'multiple'
      },
      billingColumnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Billing.billingCharge_billNo'),
          field: 'billingNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_businessNumber'),
          field: 'jobNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.invoiceHeader'),
          field: 'title',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          width: 200
        },
        { headerName: this.$t('Billing.billingCharge_bookingNo'), field: 'bookingNo', initialWidth: 200, hide: true },
        {
          headerName: this.$t('Billing.billingJob_settleAccountsTo'),
          field: 'accountId',
          width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
          }
        },
        {
          headerName: this.$t('Billing.billingJob_settlementAgent'),
          field: 'settlementAgentId',
          width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
          }
        },
        {
          headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'),
          field: 'ar',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_currency'),
          field: 'currency',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_amountOfMoney'),
          field: 'amount',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.etd'),
          field: 'billingEtd',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_vesselAndVoyage'),
          field: 'jobVesselVoyageFlight',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BillType'),
          field: 'billingType',
          width: 200,
          hide: true
        }
      ],
      billingRowData: [],
      billingGridParams: {},
      chargeGridOptions: {},
      chargeColumnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 200,
          hide: !this.showWht,
          suppressColumnsToolPanel: !this.showWht,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          width: 200,
          hide: !this.showWht,
          suppressColumnsToolPanel: !this.showWht,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        }, {
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 200,
          hide: !this.showWht,
          suppressColumnsToolPanel: !this.showWht,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_billNo'),
          field: 'billNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_businessNumber'),
          field: 'jobNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingCharge_mblNo'),
          field: 'mbl',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_settleAccountsTo'),
          field: 'accountId',
          width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_chargeItem'),
          field: 'chargeItemId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_paymentType'),
          field: 'receivable',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_currency'),
          field: 'currency',
          width: 200
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'),
          field: 'remarks',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('FinanceManage.international_agentBillNo'),
          field: 'counterPartyBillingNo',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('Billing.billingForm_unit'),
          field: 'measure',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_amount'),
          field: 'quantity',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_unitPrice'),
          field: 'unitRate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_taxIncludedPrice'),
          field: 'amount',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_taxRate'),
          field: 'taxRate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value, 6)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_taxAmount'),
          field: 'taxAmount',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value, 6)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
          colId: 'changer',
          field: 'changer',
          initialWidth: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessReferenceNumber'),
          colId: 'jobCustomerRefNo',
          field: 'jobCustomerRefNo',
          width: 150
        }
      ],
      chargeRowData: [],
      chargeGridParams: {},
      jobGridOptions: {},
      jobColumnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Billing.billingJob_businessNumber'),
          field: 'jobNo',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_customer'),
          field: 'customerId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_businessType'),
          field: 'lob',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_mblNo'),
          field: 'mbl',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_carrier'),
          field: 'carrierId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_vessel'),
          field: 'vessel',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_voyageAndFlight'),
          field: 'voyageFlight',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_portOfDischarge'),
          field: 'dischargingPortCode',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_dateOfDeparture'),
          field: 'etd',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_bookingAgent'),
          field: 'bookingAgent',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_operation'),
          field: 'op',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_sales'),
          field: 'sales',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'),
          field: 'ar',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingCharge_currency'),
          field: 'currency',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_amountOfMoney'),
          field: 'totalAmount',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('Payment.businessReferenceNumber'),
          colId: 'jobCustomerRefNo',
          field: 'jobCustomerRefNo',
          width: 150
        }
      ],
      jobRowData: [],
      jobGridParams: {},
      titleArray: [], // 开票抬头集合
      ourBankAccountArray: [], // 我司银行集合
      titleBankArray: [], // 开户银行集合
      changeStatus: false,
      arSettlementUnitOptional: false,
      addBillingConditions: { // 加入账单默认条件
        exceptKeys: [],
        accountId: 0,
        billingType: '',
        hasBillingGroup: false,
        onlyHasAgentBill: true // 是否只含有代理分成账单
      },
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 4 // 开票方式:3代表对账单
      },
      // hasLoadCharge: false, // 是否加载过费用
      // hasLoadBilling: false, // 是否加载过账单
      // hasLoadJob: false, // 是否加载过业务
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      prePrintCallback: null,
      templateSelectorDialog: { // 模板选择弹窗
        visible: false,
        cxt: null,
        category: 'GROUPBILLING',
        data: {
          BILLING_UUID: []
        }
      },
      isTabChange: false, // 是否切换页签
      showBillPaymentDialog: false,
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      },
      writeOffDialog: { visible: false },
      btnSaveEnable: false, // 是否可以点击
      invoiceMakeTypes: InvoiceConstant.BILLING_INVOICE_CATEGORY,
      hasAgentBilling: false, // 是否包含代理分成账单
      queryAgentBillingOrNot: false, // 是否查询代理分成账单
      eiTaxControlInterfaceName: '', // 电子发票税控接口类型
      toExoSystemYGSH: false // 是否阳光速航
    }
  },
  computed: {
    url() {
      return URL
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    invoiceTypes() {
      if (this.eiTaxControlInterfaceName === 'BWJSY' || this.eiTaxControlInterfaceName === 'TAX_EASY_THREE_PLUS' || this.eiTaxControlInterfaceName === 'NUONUO' || this.toExoSystemYGSH) {
        return this.billingGroup.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code || !this.billingGroup.invoiceMakeType ? InvoiceConstant.BILLING_INVOICE_TYPES : InvoiceConstant.BILLING_INVOICE_TYPES_EI
      }
      return InvoiceConstant.BILLING_INVOICE_TYPES
    }
  },
  async beforeMount() {
    await cache.load(cacheName.CONFIG)
    const billingTypeConfig = String(cache.config.get('billingType'))
    if (billingTypeConfig.indexOf('2') >= 0) {
      this.queryAgentBillingOrNot = true
    }
    if (this.actionSource === 'bill') { // 账单页面创建对账单
      this.billingGroup = this.newBillingGroup
      this.queryBillingOfBillingGroup()
      // 根据对账单的结算对象，获取对应的开票抬头
      if (this.billingGroup && this.billingGroup.accountId > 0) {
        this.queryTitleList(this.billingGroup.accountId, !StrUtils.isEmpty(this.billingGroup.title))
      }
      if (this.newBillings && this.newBillings.length > 0) {
        await this.refreshCurrencyAmount(this.newBillings)
      }
      this.queryOurBankAccountList()
    } else { // 对账单列表-查看对账单详情
      if (this.billingGroupUuid) {
        this.queryBillingGroupDetail()
      }
    }
    if (!this.isView) {
      this.btnSaveEnable = false
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.partnerManagementMode = Number(cache.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
    this.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
    this.arSettlementUnitOptional = Number(cache.config.get('ArSettlementUnitOptional')) === 1
    const billingTypeConfig = String(cache.config.get('billingType'))
    if (billingTypeConfig.indexOf('2') >= 0) {
      this.queryAgentBillingOrNot = true
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel', false)
    },
    // 查询对账单详情
    queryBillingGroupDetail() {
      this.loading = getLoading()
      getBillingGroupDetail(this.billingGroupUuid).then(res => {
        this.loading.close()
        this.billingGroup = { ...res.data }
        // 前端要重新初始化一下
        this.billingGroup.diffBillings = []
        this.billingGroup.billingKeys = []
        const accountId = this.billingGroup.accountId
        // 根据对账单的结算对象，获取对应的开票抬头
        if (accountId > 0) {
          this.queryTitleList(accountId)
        }
        this.queryOurBankAccountList()
        if (this.billingGroup && this.billingGroup.uuid) {
          const activeTabName = this.activeTabName
          if (activeTabName === 'bill') {
            this.queryBillingOfBillingGroup(this.billingGroup.uuid)
          } else if (activeTabName === 'job') {
            this.queryBillingJobOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
          } else if (activeTabName === 'charge') {
            this.queryBillingChargeOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
          }
        }
      })
    },
    // 返回按钮事件
    backEvent() {
      if (this.actionSource === 'bill') {
        this.$emit('backBillingList')
      } else {
        this.$emit('backBillingGroupList', this.billingGroup)
      }
    },
    // 页签选择事件
    handleClick(tab, event) {
      this.isTabChange = true
      this.searchConditions.pageSize = 50
      this.searchConditions.pageNum = 1
      this.searchConditions.total = 0
      const index = tab.index
      if (index === '0') {
        // 账单
        this.queryBillingOfBillingGroup(this.billingGroup.uuid)
      } else if (index === '1') {
        // 费用
        this.queryBillingChargeOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
      } else {
        // 业务
        this.queryBillingJobOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
      }
    },
    // 查询对账单所关联的账单信息
    queryBillingOfBillingGroup(uuid) {
      const conditions = []
      if (uuid) { // 针对于已经真实存在的对账单
        if (!this.isTabChange) {
          const condition = new AdvancedSearchOption(null, 'billing.BILLING_GROUP_UUID', uuid, OperatorConstants.OPERATOR_EQUAL.code)
          conditions.push(condition.formatObj2Json())
        } else { // 编辑对账单
          if (this.billingGroup.billingKeys && this.billingGroup.billingKeys.length > 0) {
            const condition = new AdvancedSearchOption(null, 'billing.UUID', this.billingGroup.billingKeys, OperatorConstants.OPERATOR_IN.code)
            conditions.push(condition.formatObj2Json())
          }
        }
      } else { // 新增对账单
        const billingKeys = []
        const billings = this.newBillings
        for (const billing of billings) {
          if (billing.uuid && billingKeys.indexOf(billing.uuid) < 0) {
            billingKeys.push(billing.uuid)
          }
        }
        const condition = new AdvancedSearchOption(null, 'billing.UUID', billingKeys, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      if (conditions.length > 0) {
        const requestBody = { conditions, pageNum: 1, pageSize: 5000, paging: true, queryAgentBillingOrNot: this.queryAgentBillingOrNot }
        this.loading = getLoading('tabPane')
        loadBillingOfBillingGroup(requestBody).then(res => {
          this.hasAgentBilling = false
          if (res.data.list && res.data.list.length > 0) {
            this.billingRowData = res.data.list
            for (let i = 0; i < this.billingRowData.length; i++) {
              const billingKey = this.billingRowData[i].uuid
              if (billingKey && this.billingGroup.billingKeys.indexOf(billingKey) < 0) {
                this.billingGroup.billingKeys.push(billingKey)
              }
              if (this.billingRowData[i].billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
                if (!this.hasAgentBilling) {
                  this.hasAgentBilling = true
                }
              }
            }
          } else {
            this.billingRowData = []
            this.billingGroup.billingKeys = []
          }
          this.searchConditions.total = Number(res.data.total)
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 查询对账单所关联的费用信息(编辑状态下，根据billingKeys去查询费用信息；查看状态下根据billingGroupUuid去查询费用信息)
    queryBillingChargeOfBillingGroup(billingGroupUuid = '') {
      const conditions = []
      if (billingGroupUuid) {
        const condition = new AdvancedSearchOption(null, 'billing.BILLING_GROUP_UUID', billingGroupUuid, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      } else {
        if (this.billingGroup.billingKeys.length > 0) {
          const condition = new AdvancedSearchOption(null, 'billing.UUID', this.billingGroup.billingKeys, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (conditions.length > 0) {
        const requestBody = { conditions, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, paging: true, queryAgentBillingOrNot: this.queryAgentBillingOrNot, branchId: this.$store.getters.currentOfficeId }
        this.loading = getLoading('tabPane')
        loadBillingChargeOfBillingGroup(requestBody).then(res => {
          if (res.data.list && res.data.list.length > 0) {
            this.chargeRowData = [...res.data.list]
          } else {
            this.chargeRowData = []
          }
          this.searchConditions.total = Number(res.data.total)
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 查询对账单所关联的业务信息(编辑状态下，根据billingKeys去查询业务信息；查看状态下根据billingGroupUuid去查询业务信息)
    queryBillingJobOfBillingGroup(billingGroupUuid = '') {
      const conditions = []
      if (billingGroupUuid) {
        const condition = new AdvancedSearchOption(null, 'billing.BILLING_GROUP_UUID', billingGroupUuid, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      } else {
        if (this.billingGroup.billingKeys.length > 0) {
          const condition = new AdvancedSearchOption(null, 'billing.UUID', this.billingGroup.billingKeys, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (conditions.length > 0) {
        const requestBody = { conditions, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, paging: true, queryAgentBillingOrNot: this.queryAgentBillingOrNot }
        this.loading = getLoading('tabPane')
        loadBillingJobOfBillingGroup(requestBody).then(res => {
          if (res.data.list && res.data.list.length > 0) {
            this.jobRowData = [...res.data.list]
          } else {
            this.jobRowData = []
          }
          this.searchConditions.total = Number(res.data.total)
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 编辑对账单
    editBillingGroup() {
      if (this.billingGroup.state > BillingConstants.BILLING_NORMAL.code) {
        this.$message.warning(this.$t('act.billingGroup.hasConfirmed', [this.billingGroup.billingNo]))
        return
      }
      this.isView = false
      this.btnSaveEnable = false
    },
    // 校验是否符合保存对账单的要求
    async saveBillingGroupDetail() {
      this.btnSaveEnable = true
      if (this.billingGroup.billingKeys.length === 0) {
        this.$message.warning(this.$t('act.billingGroup.billingNotNull'))
        return
      }
      const passThrough = await this.validateBillingGroup(this.billingRowData)
      if (!passThrough) {
        this.btnSaveEnable = false
        return
      }
      if (passThrough) {
        let hasAgentBilling = false
        if (this.billingRowData && this.billingRowData.length > 0) {
          for (const billing of this.billingRowData) {
            if (billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code) {
              hasAgentBilling = true
              break
            }
          }
        }
        this.billingGroup.hasAgentBilling = hasAgentBilling
        await saveBillingGroup(this.billingGroup).then(res => {
          this.billingGroup = { ...res.data }
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }).finally(() => {
          this.isView = true
          this.btnSaveEnable = false
          // 无论保存成功或者失败，将编辑状态为查看状态
          // 后端传回来的是一个空字符串，前端要重新初始化一下
          this.billingGroup.diffBillings = []
          this.billingGroup.billingKeys = []
          // 默认查询对账单关联的账单信息
          this.queryBillingOfBillingGroup(this.billingGroup.uuid)
        })
      }
    },
    // 查询开票抬头
    queryTitleList(accountId, hasTitle) {
      queryTitleByCpmIdx(accountId).then(res => {
        let titleArray = []
        if (res.data && res.data.length > 0) {
          titleArray = res.data
        }
        this.titleArray = titleArray
        this.titleOptionsChargeEvent(titleArray, hasTitle)
      })
    },
    // 添加账单
    addBilling() {
      const exceptKeys = []
      const rowData = this.billingRowData
      for (const billing of rowData) {
        if (!billing.billingGroupUuid && billing.uuid && exceptKeys.indexOf(billing.uuid) < 0) {
          exceptKeys.push(billing.uuid)
        }
        if (this.addBillingConditions.onlyHasAgentBill) {
          if (billing.billingType !== BillingConstants.BILLING_TYPE_AGENT.code) {
            this.addBillingConditions.onlyHasAgentBill = false
          }
        }
      }
      this.addBillingConditions.exceptKeys = exceptKeys
      this.addBillingConditions.hasBillingGroup = 0
      this.addBillingConditions.billingType = this.billingGroup.billingType
      this.addBillingConditions.accountId = this.billingGroup.accountId
      this.showJoinBillDialog = true
    },
    // 加入账单回调函数
    async backBillingGroupDetail(newBillings) {
      const billingRowData = this.billingRowData
      for (let i = 0; i < newBillings.length; i++) {
        const uuid = newBillings[i].uuid
        if (uuid) {
          this.billingGroup.diffBillings.push({ 'key': uuid, 'version': newBillings[i].version, 'action': 'add' })
          if (this.billingGroup.billingKeys.indexOf(uuid) < 0) {
            this.billingGroup.billingKeys.push(uuid)
          }
          billingRowData.push(newBillings[i])
        }
      }
      await BillingUtils.checkBillingGroupAmount(this.billingGroup, billingRowData, true)
      await this.refreshCurrencyAmount(billingRowData)
      this.showJoinBillDialog = false
    },
    // 移除账单
    removeBilling() {
      const billings = this.billingRowData
      const chooseRows = getGridSelected(this.billingGridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (billings.length === chooseRows.length) {
        this.$message.warning(this.$t('act.billingGroup.canNotRemoveAllBills'))
        return
      }
      return this.$confirm(this.$t('act.billingGroup.confirmDelete', [chooseRows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        // 记录发生变更的账单
        const diffBillings = this.billingGroup.diffBillings
        for (let i = 0; i < chooseRows.length; i++) {
          const billing = chooseRows[i]
          const uuid = billing.uuid
          if (billing.billingGroupUuid) { // 针对于对账单中原有的账单，此时账单的billingGroupUuid一定不为空，直接记录即可
            diffBillings.push({ 'key': billing.uuid, 'version': billing.version, 'action': 'delete' })
          } else { // 针对新加入的账单，然后又删除的此账单，此时要判断diffBillings中是否含有此账单，有则移除
            if (diffBillings.length > 0) {
              const index = diffBillings.findIndex(p => p.key === uuid)
              if (index >= 0) {
                diffBillings.splice(index, 1)
              }
            }
          }
          // 更新列表数据
          const index = billings.findIndex(p => p.uuid === uuid)
          if (index > -1) {
            billings.splice(index, 1)
          }
        }
        // 重新刷新对账单中的账单UUID集合
        const billingKeys = []
        for (let i = 0; i < billings.length; i++) {
          const billing = billings[i]
          const uuid = billing.uuid
          if (billingKeys.indexOf(uuid) < 0) {
            billingKeys.push(uuid)
          }
        }
        // 更新列表
        this.billingRowData = billings
        this.billingGroup.diffBillings = diffBillings
        this.billingGroup.billingKeys = billingKeys
        await BillingUtils.checkBillingGroupAmount(this.billingGroup, this.billingRowData, true)
        await this.refreshCurrencyAmount(this.billingRowData)
      }).catch(() => {
      })
    },
    // 我司银行下拉框选择回调事件
    getOurBankAccountFromChild(obj) {
      // 我司银行账号下拉选择时,带出默认维护的银行账号
      this.billingGroup.bankAccountId = obj.accountId
      this.ourBankAccountNo = obj.accountNo
    },
    changeInvoiceMakeType() {
      const elInvoiceTypes = [InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT_DEDICATED.code, InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT.code]
      if (this.billingGroup.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code && elInvoiceTypes.includes(this.billingGroup.invoiceType)) {
        this.billingGroup.invoiceType = ''
      }
    },
    // 取消保存对账单
    cancelSave() {
      if (this.actionSource === 'bill') {
        this.$emit('backBillingList', { action: 'cancelSave', data: null })
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_ModifiedDataNotSavedCancel'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.isView = true
          this.isTabChange = false
          this.queryBillingGroupDetail()
        }).catch(() => {
          // return Promise.reject('已取消确认')
        })
      }
    },
    // 验证对账单
    async validateBillingGroup(billings) {
      // 账单分公司数组
      const branchIds = []
      const currentOfficeId = this.$store.getters.currentOfficeId
      for (let i = 0; i < billings.length; i++) {
        const billing = billings[i]
        const settlementAgentId = billing.settlementAgentId
        if (!settlementAgentId || settlementAgentId === 0) {
          this.$message.warning(this.$t('act.billingGroup.settlementAgentNotNull', [billing.billingNo]))
          return false
        }
        const accountId = this.billingGroup.accountId
        if (accountId > 0 && settlementAgentId > 0 && accountId !== settlementAgentId) {
          this.$message.warning(this.$t('act.billingGroup.settlementAgentAndAccountCanNotSame', [billing.billingNo]))
          return false
        }
        const branchId = billing.branchId
        if (branchIds.indexOf(branchId) < 0) {
          branchIds.push(branchId)
        }
      }
      // 根据账单分公司的集合批量获取每个分公司对应的上级公司
      const parentOffices = await queryParentOffice(branchIds).then(res => {
        return res.data
      })
      if (parentOffices) {
        let checkChargeDetailBranch = true
        for (let j = 0; j < billings.length; j++) {
          const branchId = billings[j].branchId
          let parentOffice = null
          for (let m = 0; m < parentOffices.length; m++) {
            parentOffice = parentOffices[m]
            if (branchId === parentOffice['childOfficeId']) {
              break
            }
          }
          if (branchId !== currentOfficeId && (parentOffice && parentOffice['parentOfficeId'] !== currentOfficeId)) {
            checkChargeDetailBranch = false
            break
          }
        }
        if (!checkChargeDetailBranch) {
          this.$message.warning(this.$t('common.tips.branchSame'))
          return false
        }
      } else {
        // 请求接口出错
        return false
      }
      if (this.billingGroup.ar) {
        if (await this.getBillingTotal(true) < await this.getBillingTotal(false)) {
          this.$message.warning(this.$t('act.billingGroup.validateAp'))
          return false
        }
      } else {
        if (await this.getBillingTotal(true) > await this.getBillingTotal(false)) {
          this.$message.warning(this.$t('act.billingGroup.validateAr'))
          return false
        }
      }
      return true
    },
    // 获取应收应付总金额
    async getBillingTotal(isAr = true) {
      let total = 0
      const billings = this.billingRowData
      const inputDate = this.billingGroup.inputDate
      const localCurrency = RateUtil.localCurrencyByOffice()
      for (let i = 0; i < billings.length; i++) {
        const billing = billings[i]
        if (isAr === billing.ar) {
          if (billing.currency !== localCurrency) {
            const currency = billing.currency
            const rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, currency, inputDate, 0, 0, false)
            total = total + billing.amount * rate
          } else {
            total = total + billing.amount
          }
        }
      }
      return NumberUtils.roundHalfUp(total, 2)
    },
    // 开票抬头变更回调函数
    titleChangeEvent(titleItem) {
      this.changeStatus = true
      const billingGroup = this.billingGroup
      billingGroup.title = titleItem['title']
      billingGroup.invoiceType = titleItem['invoiceType']
      billingGroup.invoiceMakeType = titleItem['invoiceMakeType']
      this.getTitleBankByTitle(titleItem)
    },
    // 开票抬头数据源变更回调函数
    titleOptionsChargeEvent(options, hasTitle) {
      const billingGroup = this.billingGroup
      if (!billingGroup.uuid) { // 账单新增
        if (billingGroup.accountId > 0) {
          // 根据结算对象ID获取结算对象
          const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(billingGroup.accountId))
          if (!hasTitle) {
            if (!options || options.length === 0) {
              billingGroup.title = company ? company['chineseName'] : null
            } else {
              for (let i = 0; i < options.length; i++) {
                const item = options[i]
                if (item['defaultTitle'] === true) {
                  billingGroup.title = item['title']
                  billingGroup.invoiceMakeType = item['invoiceMakeType']
                  billingGroup.invoiceType = item['invoiceType']
                  break
                }
              }
            }
          }
          if (company) {
            getCustomer({ companyUuid: company['uuid'] }).then(res => {
              const customer = res.data
              billingGroup.invoiceDemand = customer ? customer['invoiceRemarks'] : ''
            })
          }
        }
      }
      if (billingGroup.title) {
        let title = null
        for (let i = 0; i < options.length; i++) {
          const item = options[i]
          if (item['title'] === billingGroup.title) {
            title = item
            break
          }
        }
        if (title) {
          if (!billingGroup.uuid) { // 创建对账单的时候默认带出
            billingGroup.invoiceMakeType = title['invoiceMakeType']
            billingGroup.invoiceType = title['invoiceType']
          }
          this.getTitleBankByTitle(title)
        }
      } else {
        this.getTitleBankByTitle()
      }
    },
    // 获取开票抬头所维护的开票银行
    async getTitleBankByTitle(title = null) {
      const billingGroup = this.billingGroup
      let changeStatus = this.changeStatus
      if (title) {
        if (title['uuid']) {
          const titleUuidList = title['uuid']
          await getTitleBankList({ titleUuidList: [titleUuidList] }).then(res => {
            const titleBanks = res.data
            if (titleBanks && titleBanks.length > 0) {
              this.titleBankArray = titleBanks
              if (!billingGroup.uuid || changeStatus) {
                for (let i = 0; i < titleBanks.length; i++) {
                  const bank = titleBanks[i]
                  if (bank['defaultBank'] === true) {
                    billingGroup.buyerBank = bank['bank']
                    billingGroup.buyerBankAccount = bank['bankAccount']
                    break
                  }
                }
              } else {
                if (!billingGroup.buyerBank) {
                  this.titleBankArray = []
                }
              }
            } else {
              this.titleBankArray = []
              billingGroup.buyerBank = ''
              billingGroup.buyerBankAccount = ''
            }
          })
        }
        if (!billingGroup.uuid || changeStatus) { // 账单新增
          changeStatus = false
          billingGroup.buyerTaxAccount = title['taxAccount']
          billingGroup.buyerAddress = title['address']
          billingGroup.buyerTelephone = title['telephone']
        }
      } else {
        billingGroup.buyerTaxAccount = ''
        billingGroup.buyerAddress = ''
        billingGroup.buyerTelephone = ''
        this.titleBankArray = []
        billingGroup.buyerBank = ''
        billingGroup.buyerBankAccount = ''
      }
      this.changeStatus = changeStatus
    },
    // 开户银行回调事件
    getBankCusFromChild(obj) {
      this.billingGroup.buyerBank = obj.bank
      this.billingGroup.buyerBankAccount = obj.bankAccount
    },
    // 查询当前分公司下的我司银行账号
    queryOurBankAccountList() {
      getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
        if (res.data && res.data.length > 0) {
          const ourBankAccountArray = res.data
          if (!this.billingGroup.uuid) { // 新建账单时默认带出账单币种对应的默认银行
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (this.billingGroup.bankAccountId > 0) {
                if (bankAccount['accountId'] === this.billingGroup.bankAccountId) {
                  this.billingGroup.bankAccountId = bankAccount['accountId']
                  this.ourBankAccountNo = bankAccount['accountNo']
                  break
                }
              } else {
                if (bankAccount['currency'] === this.billingGroup.currency && (bankAccount['defaultPayment'])) {
                  this.billingGroup.bankAccountId = bankAccount['accountId']
                  this.ourBankAccountNo = bankAccount['accountNo']
                  break
                }
              }
            }
          } else {
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (bankAccount['accountId'] === this.billingGroup.bankAccountId) {
                this.ourBankAccountNo = bankAccount['accountNo']
                break
              }
            }
          }
          this.ourBankAccountArray = ourBankAccountArray
        }
      })
    },
    // 开票/收票
    async makeInvoiceEvent() {
      await cache.load(cacheName.CONFIG)
      const InvoiceBillingGroupState = cache.config.get('InvoiceBillingGroupState')
      if (InvoiceBillingGroupState) {
        const InvoiceBillingGroupStateArray = InvoiceBillingGroupState.split(',')
        const billingStates = []
        if (InvoiceBillingGroupStateArray) {
          for (const state of InvoiceBillingGroupStateArray) {
            billingStates.push(parseInt(state))
          }
          if (!(((this.billingGroup.state === 0 || this.billingGroup.state === 1) && billingStates.indexOf(this.billingGroup.state) > -1) ||
            (billingStates.indexOf(2) > -1 && this.billingGroup.review === 1) || (billingStates.indexOf(3) > -1 && this.billingGroup.review === 0))) {
            this.$message.warning(this.$t('Clearing.InvoicingMetForReconciliationStatus'))
            return
          }
        }
      }
      if (this.billingGroup.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.makeInvoiceProperties.isAr = this.billingGroup.ar
      this.makeInvoiceProperties.isHedge = false
      this.makeInvoiceProperties.isSkipInvoiceFrom = false
      this.makeInvoiceProperties.keys = [this.billingGroup.uuid]
      this.makeInvoiceProperties.step = 'step1'
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    fetchDataByPage() {
      const activeTabName = this.activeTabName
      if (activeTabName === 'bill') {
        this.queryBillingOfBillingGroup(this.billingGroup.uuid)
      } else if (activeTabName === 'job') {
        this.queryBillingJobOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
      } else if (activeTabName === 'charge') {
        this.queryBillingChargeOfBillingGroup(this.isView ? this.billingGroup.uuid : '')
      }
    },
    // 对账单分币种合计
    async refreshCurrencyAmount(billings) {
      const billingGroup = this.billingGroup
      const billingKeys = []
      if (billings && billings.length > 0) {
        for (const billing of billings) {
          if (billing['uuid'] && billingKeys.indexOf(billing['uuid']) < 0) {
            billingKeys.push(billing['uuid'])
          }
        }
      }
      billingGroup.billingKeys = billingKeys
      if (billingKeys && billingKeys.length > 0) {
        const conditions = []
        const condition = new AdvancedSearchOption(null, 'billing.UUID', billingKeys, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
        const requestBody = { conditions, paging: false, ar: billingGroup.ar }
        await getCurrencyAmount(requestBody).then(res => {
          billingGroup.currencyAmount = res.data
        })
      }
    },
    // 对账单打印
    printEvent() {
      const params = {}
      params.BILLING_UUID = this.billingGroup.uuid
      params.fileAliasName = this.billingGroup.billingNo
      params.printSource = DocumentConstants.BATCH_PRINT_DZD.code
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'GROUPBILLING'
      this.templateSelectorDialog.visible = true
    },
    // 申请付款
    async doBillPayment() {
      if (this.billingGroup.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      const charges = await ClearingUtils.createBillPaymentByBillingGroup([this.billingGroup], -1)
      if (charges && charges.length > 0) {
        this.showBillPaymentDialog = true
        this.$refs.billPayment.initBillPayment(charges)
      }
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 销账
    writeoffHandler() {
      if (this.billingGroup.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.properties.selectedEntities = []
      const selectedEntitie = { 'uuid': this.billingGroup.uuid, 'billingNo': this.billingGroup.billingNo, 'accountId': this.billingGroup.accountId, 'billingType': this.billingGroup.billingType, 'title': this.billingGroup.title, 'currency': this.billingGroup.currency, 'amount': this.billingGroup.amount, 'state': this.billingGroup.state, 'ar': this.billingGroup.ar } // billingGroup
      this.properties.selectedEntities.push(selectedEntitie)
      if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      this.properties.writeoffBillingGroupState = String(cache.config.get('WriteoffBillingGroupState'))
      const writeoffBillingGroupState = []
      this.properties.writeoffBillingGroupState.split(',').forEach(function(value) {
        if (!isNaN(value) && value !== '') {
          writeoffBillingGroupState.push(Number(value))
        }
      })
      for (const item of this.properties.selectedEntities) {
        if (writeoffBillingGroupState.length > 0) {
          // writeoffBillingGroupState包含0、1时，根据state判断 包含2时显示已复核的对账单，writeoffBillingGroupState包含3时显示已复核的对账单
          if (!(((item.state === 0 || item.state === 1) && writeoffBillingGroupState.includes(item.state)) ||
            (writeoffBillingGroupState.includes(2) && item.review === 1) || (writeoffBillingGroupState.includes(3) && item.review === 0))) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SSNMWOR'))
            return
          }
        }
      }
      this.initEntities()
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      //
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.properties.isAr = this.properties.selectedEntities[0].ar
      this.properties.isEntitiesAr = this.properties.isAr
      this.properties.isOversea = false
      if (this.properties.selectedEntities[0].billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) this.properties.defaultCurrency = 'USD'
      this.properties.writeOffMode = 4 // 对账单
      this.properties.entities = []
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const billingTypeConfig = String(cache.config.get('billingType'))
      let queryAgentBillingCharge = false
      if (billingTypeConfig && billingTypeConfig.indexOf('2') > -1) {
        queryAgentBillingCharge = true
      }
      const requestBody = { 'keys': keys, 'classType': 'billingGroup', 'isOversea': this.properties.isOversea, 'queryAgentBillingCharge': queryAgentBillingCharge, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllSelectedSoaWrittenOff'))
        return
      }
      this.properties.accountId = this.properties.entities[0].accountId
      // 按对账单销账：未核销
      if (this.properties.writeOffMode === 4) {
        const billingGroupUuids = []
        for (const charge of this.properties.entities) {
          if (billingGroupUuids.indexOf(charge.billingGroupUuid) === -1) {
            billingGroupUuids.push(charge.billingGroupUuid)
          }
        }
        const selectedEntitiesNew = []
        for (const item of this.properties.selectedEntities) {
          if (billingGroupUuids.indexOf(item.uuid) !== -1) {
            selectedEntitiesNew.push(item)
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.currencys = []
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking) {
        this.writeOffDialog.visible = true
      }
    },
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && charge.billPaymentState < 3)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || charge.billPaymentState < 3)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputError'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.ar) {
          return false
        }
      }
      return true
    },
    async inputDateChange() {
      await BillingUtils.checkBillingGroupAmount(this.billingGroup, this.billingRowData, true)
    }
  }
}
</script>

<style lang="scss">
</style>
